var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ball",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a4c7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.6,120.1c-17.96,0-35.91.01-53.87,0-6.39,0-8.42-2.46-7.34-8.84.9-5.32,3.44-9.85,7.38-13.43,7.32-6.68,9.79-15.19,10.01-24.7.21-8.65-.41-17.46,1.01-25.91,2.75-16.45,12.83-27.45,28.39-33.36,2.18-.83,3.63-1.47,3.9-4.4C61.61,3.86,66.71-.1,72.19,0c5.47.1,10.2,4.15,10.8,9.83.24,2.32,1.17,3.07,3.14,3.77,18.71,6.6,29.95,22.53,30.05,42.46.03,5.82-.1,11.64.03,17.46.21,9.37,2.79,17.76,10.01,24.33,3.93,3.58,6.44,8.13,7.38,13.44,1.11,6.3-.97,8.79-7.39,8.8-18.2.02-36.41,0-54.61,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.45,125.17h37.13c.57,10.15-8.38,18.96-18.84,18.83-10.33-.13-19.13-9.08-18.3-18.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.644770197efd8334bd83fbb6ed64f0ff.svg";
export { ForwardRef as ReactComponent };